import React from 'react';
import styles from './style.module.scss';
import { Link } from 'react-router-dom';
import { Typography } from 'antd';

const typesColor = {
  done: 'blue',
  halfDone: 'green',
  notApi: 'red',
  notDone: 'yellow',
};

const PageRect = ({ data }) => {
  const { type = '', openNewTab = false, link } = data;

  if (data.openNewTab) {
    return (
      <a href={data.link} target={'_blank'} rel='noopener noreferrer'>
        <div className={styles.card}>
          <data.Icon fill={'#002637'} />
          <span
            style={{
              marginTop: 16,
            }}
          >
            {data.title}
          </span>
        </div>
      </a>
    );
  }
  return (
    <Link to={data.link}>
      <div className={styles.card}>
        <data.Icon fill={'#002637'} />
        <Typography.Text className={styles.card_title}>
          {data.title}
        </Typography.Text>
      </div>
    </Link>
  );
};

export default PageRect;
